const MAX_ZOOM_LEVEL = 18

const heatMapLayer = {
  maxzoom: MAX_ZOOM_LEVEL,
  type: 'heatmap',
  paint: {
    // increase weight as diameter breast height increases
    'heatmap-weight': {
      'property': 'wupd',
      'type': 'exponential',
      'stops': [
        [1, 0],
        [62, 1]
      ]
    },
    // increase intensity as zoom level increases
    'heatmap-intensity': {
      'stops': [
        [11, 1],
        [18, 3]
      ]
    },
    // use sequential color palette to use exponentially as the weight increases
    'heatmap-color': [
      'interpolate',
      ['linear'],
      ['heatmap-density'],
      0,
      'rgba(236,222,239,0)',
      0.1,
      'rgb(116,204,255)',
      0.2,
      'rgb(116,204,244)',
      0.4,
      'rgb(28,163,236)',
      0.6,
      'rgb(28,163,236)',
      0.8,
      'rgb(35,137,218)',
      1,
      'rgb(15,94,156)'
    ],
    // increase radius as zoom increases
    'heatmap-radius': {
      'stops': [
        [11, 18],
        [18, 20]
      ]
    },
    // decrease opacity to transition into the circle layer
    'heatmap-opacity': {
      'default': 1,
      'stops': [
        [14, 1],
        [18, 0]
      ]
    }
  }
}

export default heatMapLayer
